import { Box, Container, Icon, Typography } from "@mui/material";
import DialogContext from "components/confirm-dialog-context";
import FloatingActions, { FloatingActionsProps } from "components/floatingactions/FloatingActions";
import { CustomButton } from "components/roundedbutton/CustomButton";
import useCatchApiError from "hooks/useCatchApiError";
import useFlowRoles from "hooks/useFlowRoles";
import { useSnackbarCustom } from "hooks/useSnackCustom";
import JsBarcode from 'jsbarcode';
import CaixaService from "pages/Caixa/caixa.service";
import PdfComprovanteCrediario from "pages/comprovante-nota-fiscal-outros/PdfComprovanteCrediarios";
import PdfComprovanteTemplate from "pages/comprovante-nota-fiscal-outros/PdfComprovanteTemplate";
import LoginService from "pages/login/login.service";
import PreVendaPdf, { PreVendaState } from "pages/registra-venda/PreVendaPdf";
import { FlowVendaTO } from "pages/registra-venda/registra-venda.model";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { resetCaixa, setCaixa } from "redux/features/caixaSlice";
import { setDeposito, setTabelaPreco } from "redux/features/configuracoes";
import { setPagamentos } from "redux/features/pagamentoSlice";
import { resetState, setStateByProps, setTransportador } from "redux/features/stateSlice";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { theme } from "theme";
import { removeChequesSemDados } from "utils/pagamento-cheque";
import { captalizeString } from "utils/util";
import { axiosRequest } from '../../../src/axios/axios.config';
import EtiquetaSimplificada from "./EtiquetaSimplificada";
import EtiquetaVolume from "./EtiquetaVolume";
import CustomIFrame from "./Header/CustomIFrame";
import CustomLoading from "./Header/CustomLoading";
import Data from "./Header/Data";
import PesquisaVenda from "./Header/Pesquisavenda";
import SituacaoDocumentoFiscal from "./Header/SituacaoDocumentoFiscal";
import Status from "./Header/Status";
import RomaneioVenda from "./RomaneioVenda";
import VendasTable from "./VendasTable";
import VendaService from "./venda.service";
import { Assosicacao, EtiquetaSimplificadaDTO, EtiquetaVolumeDTO, getAssociacao, ItemRelatorioVendas, StatusNotaFiscal, StatusPedido, TDadosFooter, TipoRelatorioVenda, TVisualizarVenda } from './vendas.model';
import VisualizarVenda from "components/venda/VisualizarVenda";

export const gerarBarcodeBase64 = (value: string): string => {
    const canvas = document.createElement('canvas');
    JsBarcode(canvas, value, {
        format: 'CODE128',
        width: 2,
        height: 60,
        displayValue: false
    });
    return canvas.toDataURL("image/png");
};

const allStatusPedidoOptions = [StatusPedido.FATURADO, StatusPedido.ABERTO, StatusPedido.CANCELADO, StatusPedido.AGRUPADO];
const allTipoRelatorioVendas = [TipoRelatorioVenda.PEDIDO, TipoRelatorioVenda.NOTA];

const situacaoNotaFiscalInitialState = [
    captalizeString(StatusNotaFiscal.AUTORIZADA),
    captalizeString(StatusNotaFiscal.PENDENTE),
    captalizeString(StatusNotaFiscal.REJEITADA),
    captalizeString(StatusNotaFiscal.PROCESSANDO),
];

const allSituacaoNotaFiscalOptions = [
    captalizeString(StatusNotaFiscal.AUTORIZADA),
    captalizeString(StatusNotaFiscal.PENDENTE),
    captalizeString(StatusNotaFiscal.REJEITADA),
    captalizeString(StatusNotaFiscal.PROCESSANDO),
    captalizeString(StatusNotaFiscal.DENEGADA),
    captalizeString(StatusNotaFiscal.CANCELADA),
];
const statusPedidoInitialState = [StatusPedido.FATURADO, StatusPedido.ABERTO];

const initialState = {
    pesquisaVenda: '' as string,
    statusPedido: statusPedidoInitialState as Array<StatusPedido>,
    situacaoNotaFiscal: situacaoNotaFiscalInitialState as Array<string>,
    dataInicio: new Date().toString() as string,
    dataFim: new Date().toString() as string,
    situacaoOptions: allStatusPedidoOptions as Array<StatusPedido>,
    totalizadores: [] as Array<ItemRelatorioVendas>,
    totalizadoresError: false as boolean,
    dadosFooter: {
        quantidade: 0,
        totalPedido: 0,
        totalNota: 0
    } as TDadosFooter,
    loading: true as boolean,
    showTooltip: false as boolean,
    showLoadingNavegandoPDV: false as boolean,
    showLoadingComprovanteNaoFiscal: false as boolean,
    showComprovanteFolhaA4: false as boolean,
    showComprovantePreVenda: false as boolean,
    showCrediario: false as boolean,
    showEtiquetaVolume: false as boolean,
    dadosEtiqueta: null as EtiquetaVolumeDTO | null,
    showEtiquetaSimplificada: false as boolean,
    etiquetaSimplificada: null as EtiquetaSimplificadaDTO | null,
    barCode: "" as string,
    tipoRelatorioVenda: TipoRelatorioVenda.PEDIDO as TipoRelatorioVenda,
    visualizarVenda: {
        open: false,
        data: null
    } as TVisualizarVenda
};

type KeyListStatusPedido = Array<keyof typeof StatusPedido>;

type KeyListSituacaoNotaFiscal = Array<keyof typeof StatusNotaFiscal>;


export type TCancelapedido = {
    pedidoUUID: string,
    motivoUUID: string;
};

const getKeyOfStatuspedido = (status: Array<StatusPedido>): KeyListStatusPedido => {
    return status.map(s => Object.keys(StatusPedido).find(key => (StatusPedido as any)[key] === s)) as KeyListStatusPedido;
};

const getKeyOfSituacaoNotaFiscal = (situacao: Array<string>): KeyListSituacaoNotaFiscal => {
    return situacao.map(s => Object.keys(StatusNotaFiscal).find(key => (StatusNotaFiscal as any)[key] === s)) as KeyListSituacaoNotaFiscal;
};

let timer: NodeJS.Timeout;

const initialStatePrevenda: PreVendaState = {
    cliente: '',
    vendedor: '',
    emissao: '',
    numero: '',
    observacao: '',
    valorTotalBruto: 0,
    valorTotalLiquido: 0,
    valorAcrescimo: 0,
};

const Venda = () => {
    const [stateLocal, setStateLocal] = useState(initialState);
    const { canAgrupar } = useFlowRoles().venda.acoes;
    const { canNovo } = useFlowRoles().venda;
    const [state, setState] = useState({
        showImprimirDFE: false,
        url: ""
    }
    );

    const [prevenda, setPrevenda] = useState(initialStatePrevenda);
    const navigate = useNavigate();
    const vendaService = VendaService();
    const { addError, addSuccess, addWarning, closeSnack } = useSnackbarCustom();
    const { throwErrorMessage } = useCatchApiError();
    const { caixaAberto } = useAppSelector(e => e.caixa.caixaAtual);
    const estabelecimento = useAppSelector(e => e.estabelecimentoSelecionado);
    const estabelecimentoRef = useRef<string>(estabelecimento.uuid);
    const { descritivo } = useAppSelector(e => e.estabelecimentoSelecionado);
    const [showComprovanteOutros, setShowComprovanteOutros] = useState<{ open: boolean, pedido: FlowVendaTO | null; }>({
        open: false,
        pedido: null
    });
    const caixaService = CaixaService();
    const dispatch = useAppDispatch();
    const loginService = LoginService();
    const token = useAppSelector(e => e.token);
    const { pedido } = useAppSelector(e => e.state);
    const location = useLocation();
    const [selectedRows, setSelectedRows] = useState<string[]>([]);
    const [openAgruparPedidos, setOpenAgruparPedidos] = useState(false);
    const dialogAgruparPedidos = useContext(DialogContext);

    const floatingActions: FloatingActionsProps = {
        actions: [
            {
                label: 'Agrupar pedido',
                icon: 'fa-solid fa-cart-arrow-down',
                onClick: () => {
                    handleClickDialog();
                },
                disabled: () => !canAgrupar || selectedRows.length < 2,
            }
        ]
    };

    const handleClickDialog = () => {
        dialogAgruparPedidos.confirm({
            title: "Confirmação de agrupamento",
            message: (
                <>
                    <Typography
                        sx={{
                            fontSize: "clamp(12px, 2vw, 16px)",
                            whiteSpace: "pre-line",
                        }}
                        textAlign="center"
                        fontWeight={500}
                    >
                        {`Os pedidos selecionados serão agrupados em um novo pedido.

                                        Deseja continuar?`}
                    </Typography>
                </>
            ),
            onConfirm: () => {
                navegaPDFAgruparPedidos(selectedRows);
            },
            onCancel: () => { },
            useCustomButton: true,
        });
        setOpenAgruparPedidos(!openAgruparPedidos);
    };

    const atualizaRelatorio = () => {
        if (!stateLocal.loading) {
            setStateLocal(prevState => ({ ...prevState, loading: true }));
        }
        if (location.state?.numeroPedido) {
            setStateLocal(prevState => ({ ...prevState, pesquisaVenda: "" + location.state.numeroPedido }));
            location.state = null;
        }
        const vendaStatusNameArray = getKeyOfStatuspedido(stateLocal.statusPedido);
        const vendaSituacaoNameArray = getKeyOfSituacaoNotaFiscal(stateLocal.situacaoNotaFiscal.map(e => e.toUpperCase()));
        const datas = [new Date(stateLocal.dataInicio).toISOString().split("T")[0], new Date(stateLocal.dataFim).toISOString().split("T")[0]];

        vendaService.getRelatorio(stateLocal.pesquisaVenda, datas, vendaStatusNameArray, vendaSituacaoNameArray, stateLocal.tipoRelatorioVenda)
            .then(({ data }) => {
                if (!data.length) {
                    return setStateLocal(prevState => ({ ...prevState, totalizadoresError: true, totalizadores: data, loading: false }));
                }

                const quantidade = data.length;
                const totalNota = data.filter(e => e.valorNota).reduce((prev, current) => prev + current.valorNota, 0);
                const totalPedido = data.filter(e => e.valorPedido).reduce((prev, current) => prev + current.valorPedido, 0);

                return setStateLocal(prevState => ({
                    ...prevState,
                    totalizadores: data,
                    totalizadoresError: false,
                    dadosFooter: {
                        quantidade,
                        totalNota,
                        totalPedido
                    },
                    loading: false
                }));
            })
            .catch(error => {
                if (error.code === "ERR_NETWORK") {
                    addError({ message: "Sistema temporariamente indisponivel. Se o erro persistir, contate o suporte", closeable: true, persist: true, id: "sistema-indisponivel-error", preventDuplicate: true });
                }
                throwErrorMessage(error);
                setStateLocal(prevState => ({
                    ...prevState,
                    totalizadores: [],
                    totalizadoresError: true,
                    dadosFooter: {
                        quantidade: 0,
                        totalNota: 0,
                        totalPedido: 0
                    },
                    loading: false,
                }
                ));
            });
    };

    useEffect(() => {
        if (pedido.valorTotalBruto && pedido.itens.length) {
            dispatch(resetState());
        }
        //eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (estabelecimento.uuid !== estabelecimentoRef.current) {
            closeSnack('venda-falha-saldo-conta');
            closeSnack('venda-falha-caixas-disponiveis');
            estabelecimentoRef.current = estabelecimento.uuid;
            axiosRequest.get(`/flow/existeconfiguracao`, { headers: loginService.getHeaders() })
                .then(() => {
                    setStateLocal(prevState => ({ ...prevState, error: false }));
                    caixaService.getCaixas()
                        .then(({ data }) => {
                            const caixa = data.find(e => e.caixaAberto && e.operadorAtual === token.USER_INFO?.username);
                            if (!caixa) return dispatch(resetCaixa());
                            caixaService.getSaldoConta(caixa.uuid)
                                .then(({ data }) => {
                                    dispatch(setCaixa({
                                        caixa: data.caixa,
                                        contaSelecionada: null,
                                        saldo: data.saldo,
                                        dataAbertura: data.dataAbertura,
                                        caixaAberto: data.caixaAberto
                                    }));
                                })
                                .catch(() => {
                                    addError({ id: 'venda-falha-saldo-conta', message: 'Falha ao pegar o saldo da conta informada.', closeable: true });
                                });
                        }).catch(() => {
                            addError({ id: 'venda-falha-caixas-disponiveis', message: 'Falha ao pegar caixas disponiveis.', closeable: true });
                        });
                })
                .catch((error: any) => {
                    setStateLocal(prevState => ({ ...prevState, error: true }));
                    dispatch(resetCaixa());
                    throwErrorMessage(error);
                });
            atualizaRelatorio();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [estabelecimento.uuid]);


    useEffect(() => {
        atualizaRelatorio();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [stateLocal.dataInicio, stateLocal.dataFim, JSON.stringify(stateLocal.statusPedido), stateLocal.situacaoNotaFiscal, stateLocal.tipoRelatorioVenda]);

    useEffect(() => {
        setStateLocal(prevstate => {
            let statusPedido = prevstate.statusPedido;
            if (stateLocal.tipoRelatorioVenda === TipoRelatorioVenda.NOTA) {
                statusPedido = statusPedido.filter(e => e !== StatusPedido.ABERTO);
            } else if (!statusPedido.includes(StatusPedido.ABERTO)) {
                statusPedido.push(StatusPedido.ABERTO);
            }

            return {
                ...prevstate,
                statusPedido,
            };
        });
    }, [stateLocal.tipoRelatorioVenda]);

    useEffect(() => {
        if (stateLocal.totalizadores) {
            timer = setTimeout(() => {
                atualizaRelatorio();
            }, 300);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [stateLocal.pesquisaVenda]);

    useEffect(() => {
        if (!stateLocal.statusPedido.includes(StatusPedido.FATURADO)
            && (stateLocal.statusPedido.includes(StatusPedido.ABERTO) || stateLocal.statusPedido.includes(StatusPedido.CANCELADO))) {
            return setStateLocal(prevState => ({ ...prevState, situacaoNotaFiscal: [] }));
        }
        if (stateLocal.statusPedido.includes(StatusPedido.FATURADO) && !stateLocal.situacaoNotaFiscal.length) {
            return setStateLocal(prevState => ({ ...prevState, situacaoNotaFiscal: situacaoNotaFiscalInitialState }));
        }
        // eslint-disable-next-line
    }, [stateLocal.statusPedido]);

    const changePesquisavenda = useCallback((pesquisaVenda: string) => {
        if (timer) { clearTimeout(timer); }
        setStateLocal(prevState => ({ ...prevState, pesquisaVenda }));
    }, []);

    const showImprimirDFE = useCallback((url: string) => {
        setState(prevState => ({ ...prevState, showImprimirDFE: true, url }));
    }, []);

    const changeStatus = useCallback((statusPedido: Array<StatusPedido> | TipoRelatorioVenda) => {
        if (Array.isArray(statusPedido)) {
            setStateLocal(prevState => ({ ...prevState, statusPedido }));
        }
    }, []);

    const changeSituacao = useCallback((situacaoNotaFiscal: any) => {
        setStateLocal(prevState => ({ ...prevState, situacaoNotaFiscal }));
    }, []);

    const changeData = useCallback((state: string, value: string) => {
        setStateLocal(prevState => ({ ...prevState, [state]: value }));
    }, []);

    const customIFrameClose = useCallback(() => {
        setState(prevState => ({ ...prevState, showImprimirDFE: false }));
    }, []);

    const aplicaPagamentosDoPedido = (data: FlowVendaTO) => {
        const pagamentos = removeChequesSemDados(data.itensPagamento ?? []);
        if (pagamentos.removidos > 0) {
            addWarning({
                message: 'Os dados do cheque foram perdidos no cancelamento da nota. Informe a forma de pagamento novamente.',
                closeable: true,
                persist: true,
                id: 'cheque-sem-dados-pedido-reaberto',
                preventDuplicate: true,
            });
        }
        dispatch(
            setPagamentos({
                itens: pagamentos.itens,
                itensTroca: data.itensPagamentoDevolucao ?? [],
            }),
        );
    };

    const cancelaPedido = (pedidoUUID: string, motivoUUID: string) => {
        const toCancel: TCancelapedido = {
            motivoUUID,
            pedidoUUID,
        };

        vendaService.cancelaPedido(toCancel)
            .then(() => {
                addSuccess({ message: "Pedido cancelado com sucesso", closeable: true, hideDuration: 4000, id: 'pedido-cancelado-alert', });
                atualizaRelatorio();
            })
            .catch(() => { });
    };

    const navegaPDFAgruparPedidos = (uuidsPedidos: String[]) => {
        return vendaService.agruparPedidos(uuidsPedidos)
            .then(({ data }: { data: FlowVendaTO; }) => {
                setStateLocal(prevState => ({ ...prevState, showLoadingNavegandoPDV: false }));
                if (data.statusPedido === StatusPedido.ABERTO.toString().toUpperCase()) {
                    if (data.tabelaPreco) dispatch(setTabelaPreco(data.tabelaPreco));
                    if (data.deposito) dispatch(setDeposito(data.deposito));
                    if (data.transportador) dispatch(setTransportador(data.transportador));
                    data.itens.forEach(e => e.estoque = -1);
                    dispatch(setStateByProps(data));
                    aplicaPagamentosDoPedido(data);
                    setTimeout(() => {
                        navigate("/registra-venda", { state: true });
                    }, 200);
                    return;
                }
                addError({
                    message: `Não foi possivel agrupar os pedidos selecionados`,
                    closeable: true
                });
                atualizaRelatorio();
            })
            .catch((err) => {
                setStateLocal(prevState => ({ ...prevState, showLoadingNavegandoPDV: false }));
                throwErrorMessage(err);
            });

    };

    const navegaPDV = (uuid: string, numeroPedido: number) => {
        setStateLocal(prevState => ({ ...prevState, showLoadingNavegandoPDV: true }));
        if (!caixaAberto) {
            setStateLocal(prevState => ({ ...prevState, showLoadingNavegandoPDV: false }));
            return addError({
                message: `Abra um caixa para movimentar o pedido ${numeroPedido}`,
                closeable: true
            });
        }
        return vendaService.carregaPedido(uuid)
            .then(({ data }: { data: FlowVendaTO; }) => {
                setStateLocal(prevState => ({ ...prevState, showLoadingNavegandoPDV: false }));
                if (data.statusPedido === StatusPedido.ABERTO.toString().toUpperCase()) {
                    if (data.tabelaPreco) dispatch(setTabelaPreco(data.tabelaPreco));
                    if (data.deposito) dispatch(setDeposito(data.deposito));
                    if (data.transportador) dispatch(setTransportador(data.transportador));
                    data.itens.forEach(e => e.estoque = -1);
                    dispatch(setStateByProps(data));
                    aplicaPagamentosDoPedido(data);
                    setTimeout(() => {
                        navigate("/registra-venda", { state: true });
                    }, 200);
                    return;
                }
                addError({
                    message: `O pedido ${numeroPedido} já foi faturado em outra transação`,
                    closeable: true
                });
                atualizaRelatorio();
            })
            .catch(() => {
                setStateLocal(prevState => ({ ...prevState, showLoadingNavegandoPDV: false }));
                addError({ message: "Sistema temporariamente indisponivel. Se o erro persistir, contate o suporte", closeable: true, persist: true, id: "sistema-indisponivel-error", preventDuplicate: true });
            });
    };

    const onVisualizar = useCallback(async (uuid: string, numeroPedido: number) => {
        setStateLocal(prevState => ({
            ...prevState,
            visualizarVenda: {
                ...prevState.visualizarVenda,
                open: true,
            }
        }))
        try {
            const { data } = await vendaService.carregaPedido(uuid);
            setStateLocal(prevState => ({
                ...prevState,
                visualizarVenda: {
                    ...prevState.visualizarVenda,
                    data
                }
            }))
        }
        catch {
            setStateLocal(prevState => ({
                ...prevState, visualizarVenda: {
                    open: false,
                    data: null
                }
            }));
            addError({ message: "Sistema temporariamente indisponivel. Se o erro persistir, contate o suporte", closeable: true, persist: true, id: "sistema-indisponivel-error", preventDuplicate: true });
        }
        //eslint-disable-next-line
    }, [estabelecimento.uuid]);

    const onCloseVisualizarVenda = () => {
        return setStateLocal(prevState => ({
            ...prevState,
            visualizarVenda: {
                open: false,
                data: null
            }
        }))
    }

    const navegaPreVenda = (uuid: string, numeroPedido: number) => {
        setStateLocal(prevState => ({ ...prevState, showLoadingNavegandoPDV: true }));
        return vendaService.carregaPedido(uuid)
            .then(({ data }: { data: FlowVendaTO; }) => {
                setStateLocal(prevState => ({ ...prevState, showLoadingNavegandoPDV: false }));
                if (data.statusPedido === StatusPedido.ABERTO.toString().toUpperCase()) {
                    if (data.tabelaPreco) dispatch(setTabelaPreco(data.tabelaPreco));
                    if (data.deposito) dispatch(setDeposito(data.deposito));
                    if (data.transportador) dispatch(setTransportador(data.transportador));
                    dispatch(setStateByProps(data));
                    aplicaPagamentosDoPedido(data);
                    setTimeout(() => {
                        return navigate("/pre-venda", { state: true });
                    }, 200);
                    return;
                }
                addError({
                    message: `O pedido ${numeroPedido} já foi faturado em outra transação`,
                    closeable: true
                });
                atualizaRelatorio();
            })
            .catch(error => {
                setStateLocal(prevState => ({ ...prevState, showLoadingNavegandoPDV: false }));
                addError({ message: "Sistema temporariamente indisponivel. Se o erro persistir, contate o suporte", closeable: true, persist: true, id: "sistema-indisponivel-error", preventDuplicate: true });
            });
    };

    const showImprimirOutros = useCallback((uuid: string) => {
        setStateLocal(prevState => ({ ...prevState, showLoadingComprovanteNaoFiscal: true }));
        vendaService.carregaPedido(uuid)
            .then(({ data }: { data: FlowVendaTO; }) => {
                setShowComprovanteOutros(prevState => ({ ...prevState, open: true, pedido: data }));
            }).catch(() => {
                addError({ message: "Sistema temporariamente indisponivel. Se o erro persistir, contate o suporte", closeable: true, persist: true, id: "sistema-indisponivel-error", preventDuplicate: true });
            }).finally(() => {
                setStateLocal(prevState => ({ ...prevState, showLoadingComprovanteNaoFiscal: false }));
            });
        // eslint-disable-next-line
    }, [estabelecimento.uuid]);

    const flowVendaTORef = useRef<FlowVendaTO | null>(null);

    const showRomaneioVenda = (uuid: string) => {
        setStateLocal(prevState => ({ ...prevState, showLoadingNavegandoPDV: true }));
        vendaService.carregaPedido(uuid)
            .then(({ data }) => {
                flowVendaTORef.current = data;
                setStateLocal(prevState => ({ ...prevState, showComprovanteFolhaA4: true, showLoadingNavegandoPDV: false }));
            })
            .catch((err) => {
                addError({ message: "Não foi possivel imprimir o romaneio", closeable: true, id: "erro-impressao-romaneio", preventDuplicate: true });
                setStateLocal(prevState => ({ ...prevState, showLoadingNavegandoPDV: false }));
            });
    };

    const emissaoNotaRef = useRef<Date | undefined>(undefined);

    const imprimirCrediario = (uuid: string, emissaoNota: Date | undefined) => {
        setStateLocal(prevState => ({ ...prevState, showLoadingComprovanteNaoFiscal: true }));
        vendaService.carregaPedido(uuid)
            .then(({ data }) => {
                const validateCrediario = data.itensPagamento.some(e => e.formaPagamento.descritivo === "CREDIÁRIO");
                if (!validateCrediario) {
                    setStateLocal(prevState => ({ ...prevState, showLoadingComprovanteNaoFiscal: false }));
                    return addError({
                        message: "Pedido não possui forma de pagamento crediário"
                        , closeable: true,
                        id: "erro-impressao-A4",
                        preventDuplicate: true
                    });
                }

                flowVendaTORef.current = data;
                if (emissaoNota) {
                    emissaoNotaRef.current = emissaoNota;
                }

                setStateLocal(prevState => ({
                    ...prevState,
                    showCrediario: true,
                    showLoadingComprovanteNaoFiscal: false
                }));
            })
            .catch((err) => {
                addError({ message: "Não foi possivel imprimir o romaneio", closeable: true, id: "erro-impressao-romaneio", preventDuplicate: true });
                setStateLocal(prevState => ({
                    ...prevState,
                    showLoadingComprovanteNaoFiscal: false,
                }));
            });
    };

    const onImprimirEtiquetaVolume = useCallback(async (uuid: string) => {
        try {
            const { data } = await vendaService.imprimirEtiquetaVolume(uuid);
            setStateLocal(prevState => ({
                ...prevState,
                showEtiquetaVolume: true,
                dadosEtiqueta: data
            }));
        } catch (err) {
            throwErrorMessage(err ?? []);
        }
        //eslint-disable-next-line
    }, [estabelecimento.uuid]);


    const onImprimirEtiquetaSimplificada = useCallback(async (chaveAcesso: string) => {
        try {
            const { data } = await vendaService.imprimirEtiquetaSimplificada(chaveAcesso);
            const barCode = gerarBarcodeBase64(chaveAcesso);
            setStateLocal(prevState => ({
                ...prevState,
                showEtiquetaSimplificada: true,
                etiquetaSimplificada: data,
                barCode: barCode
            }));
        } catch (err: any) {
            const userMessage = err.response.data.userMessage;
            if (userMessage && userMessage.includes("Acesso não autorizado")) {
                return addError({ message: "Perfil sem acesso: Fiscal | Documento de saida | imprimir-dfe-simplificada", closeable: true });
            }
            else {
                throwErrorMessage(err ?? []);
            }
        }
        //eslint-disable-next-line
    }, []);


    const imprimirPreVenda = (itemRelatorio: ItemRelatorioVendas) => {
        setStateLocal(prevState => ({ ...prevState, showLoadingNavegandoPDV: true, showComprovantePreVenda: false }));

        setTimeout(() => {
            vendaService.carregaPedido(itemRelatorio.uuidPedido)
                .then(({ data }) => {
                    setPrevenda({
                        cliente: data.cliente?.descritivo?.split(" - ")[1] ?? "CONSUMIDOR",
                        numero: data.numero,
                        vendedor: data.vendedorPrincipal?.descritivo?.split(" - ")[1] ?? "",
                        valorTotalLiquido: data.valorTotalLiquido,
                        emissao: data.emissao,
                        observacao: data.observacao,
                        valorTotalBruto: data.valorTotalBruto,
                        valorAcrescimo: data.pedidoDescontoAcrescimo.acrescimo,
                    });
                    setStateLocal(prevState => ({ ...prevState, showComprovantePreVenda: true, showLoadingNavegandoPDV: false }));
                })
                .catch((err) => {
                    addError({ message: "Não foi possivel imprimir o comprovante de pré venda", closeable: true, id: "erro-impressao-pre-venda", preventDuplicate: true });
                    setStateLocal(prevState => ({ ...prevState, showLoadingNavegandoPDV: false }));
                })
                .finally(() => {
                    setTimeout(() => {
                        setStateLocal(prevState => ({ ...prevState, showLoadingNavegandoPDV: false }));
                    }, 500);
                });
        }, 500);
    };

    const onCloseComprovantePreVenda = useCallback(() => {
        flowVendaTORef.current = null;
        setStateLocal(prevState => ({ ...prevState, showComprovantePreVenda: false }));
    }, []);

    const onCloseCrediario = useCallback(() => {
        setStateLocal(prevState => ({ ...prevState, showCrediario: false }));
    }, []);

    const onCloseEtiquetaVolume = useCallback(() => {
        setStateLocal(prevState => ({ ...prevState, showEtiquetaVolume: false }));
        //eslint-disable-next-line
    }, []);

    const onCloseEtiquetaSimplificada = useCallback(() => {
        setStateLocal(prevState => ({ ...prevState, showEtiquetaSimplificada: false }));
        //eslint-disable-next-line
    }, []);

    const goBackA4 = () => {
        flowVendaTORef.current = null;
        setStateLocal(prevState => ({ ...prevState, showComprovanteFolhaA4: false }));
    };

    const closeShowImprimirOutros = useCallback(() => {
        setShowComprovanteOutros(prevState => ({ ...prevState, open: false, pedido: null }));
    }, []);

    const handleNavegaConferencia = useCallback((uuid: string) => {
        navigate('/conferencia/' + uuid);
        //eslint-disable-next-line
    }, []);

    const onChangeTipoRelatorioVendas = useCallback((tipoRelatorioVenda: TipoRelatorioVenda | Array<StatusPedido>) => {
        if (Array.isArray(tipoRelatorioVenda)) return;
        setStateLocal(prevState => ({
            ...prevState, tipoRelatorioVenda,
        }));
        //eslint-disable-next-line
    }, []);

    return (
        <Container
            maxWidth="xl"
            sx={{
                marginTop: '40px',
            }}>
            <Box
                maxHeight="xl"
                sx={{
                    height: 'calc(100vh - 224px)',
                    display: 'grid',
                    gridTemplateRows: { md: `50px 50px auto 100px 50px`, xs: `auto auto 450px auto auto` },
                    gap: '20px',
                }}>
                <Box sx={{
                    width: '100%',
                    height: '50px',
                    display: 'flex',
                    gap: '2%'
                }}>
                    <PesquisaVenda
                        label={`Número ${stateLocal.tipoRelatorioVenda === TipoRelatorioVenda.PEDIDO ? 'do pedido' : 'da nota'} ou cliente`}
                        pesquisaValue={stateLocal.pesquisaVenda}
                        onChangePesquisa={changePesquisavenda}
                    />
                    <Status
                        title="Buscar por"
                        options={allTipoRelatorioVendas}
                        values={stateLocal.tipoRelatorioVenda}
                        onChange={onChangeTipoRelatorioVendas}
                        multiple={false}
                        width="15%"
                    />
                    <Data
                        title="Data inicial emissão"
                        dataValue={stateLocal.dataInicio}
                        onChangeData={changeData}
                        dataInicio={stateLocal.dataInicio}
                        dataFim={stateLocal.dataFim}
                        state='dataInicio'
                    />
                    <Data
                        title="Data final emissão"
                        dataValue={stateLocal.dataFim}
                        onChangeData={changeData}
                        dataInicio={stateLocal.dataInicio}
                        dataFim={stateLocal.dataFim}
                        state='dataFim'
                    />
                    <Status
                        disabled={stateLocal.tipoRelatorioVenda === TipoRelatorioVenda.NOTA}
                        options={allStatusPedidoOptions}
                        values={stateLocal.statusPedido}
                        onChange={changeStatus}
                        title="Status do pedido"
                        width="30%"
                    />
                    <SituacaoDocumentoFiscal
                        situacaoOptions={allSituacaoNotaFiscalOptions}
                        situacaoValues={stateLocal.situacaoNotaFiscal}
                        isDisabled={!stateLocal.statusPedido.includes(StatusPedido.FATURADO)}
                        onChangeSituacao={changeSituacao}
                    />
                </Box>
                <Box>
                    <VendasTable
                        totalizadores={stateLocal.totalizadores}
                        totalizadoresError={stateLocal.totalizadoresError}
                        dadosFooter={stateLocal.dadosFooter}
                        isLoading={false}
                        onCancelaPedido={cancelaPedido}
                        onNavegaPDV={navegaPDV}
                        onAtualizarRelatorio={atualizaRelatorio}
                        onShowImprimirDFE={showImprimirDFE}
                        onShowImprimirOutros={showImprimirOutros}
                        onShowRomaneioVenda={showRomaneioVenda}
                        onImprimirPreVenda={imprimirPreVenda}
                        onNavegaPreVenda={navegaPreVenda}
                        onVisualizar={onVisualizar}
                        onImprimirCrediario={imprimirCrediario}
                        handleNavegaConferencia={handleNavegaConferencia}
                        onImprimirEtiquetaVenda={onImprimirEtiquetaVolume}
                        onImprimirEtiquetaSimplificada={onImprimirEtiquetaSimplificada}
                        selectedRows={selectedRows}
                        setSelectedRows={setSelectedRows}
                    />
                    <Box sx={{
                        width: '100%',
                        marginTop: '20px',
                        justifyContent: 'space-between',
                    }}>
                        <Typography sx={{ color: theme.palette.common.black }}>{"Legenda Fiscal"}</Typography>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', maxHeight: '60px' }}>
                            <Box sx={{ display: 'flex', marginTop: '10px', gap: '6px' }}>
                                {Object.keys(Assosicacao).map((e, i) => {
                                    return (
                                        <Box key={`associacao_${e}`}>
                                            <Box sx={{
                                                height: '20px',
                                                width: '105px',
                                                bgcolor: getAssociacao(e).rgb,
                                                border: '1px solid grey',
                                                borderRadius: '5px'
                                            }} >
                                            </Box>
                                            <Typography sx={{ fontSize: '12px', textAlign: 'center' }}>
                                                {captalizeString(getAssociacao(e).statusNotaFiscal)}
                                            </Typography>
                                        </Box>
                                    );
                                })}
                            </Box>

                            <Box sx={{ display: 'flex', gap: 1, justifyContent: 'right', alignItems: 'flex-end', marginBottom: '20px' }}>
                                <CustomButton
                                    sx={{ marginLeft: '10px', minWidth: '80px', width: "12vw" }}
                                    id="vendas_irpdv_btn"
                                    disabled={!caixaAberto || !canNovo}
                                    onClick={() => { navigate("/registra-venda"); }}
                                    variant="contained"
                                    color="success"
                                    startIcon={<Icon className='fa-solid fa-arrow-right' />}>
                                    Ir para o PDV
                                </CustomButton>
                                <FloatingActions   {...floatingActions} />
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box >

            {state.showImprimirDFE &&
                <CustomIFrame
                    url={state.url}
                    onClose={customIFrameClose}
                />
            }
            {(stateLocal.loading || stateLocal.showLoadingNavegandoPDV || stateLocal.showLoadingComprovanteNaoFiscal) &&
                <CustomLoading />
            }
            {showComprovanteOutros.open && showComprovanteOutros.pedido &&
                <PdfComprovanteTemplate
                    descritivo={descritivo}
                    flowVendaTO={showComprovanteOutros.pedido}
                    onCloseComprovante={closeShowImprimirOutros}
                    showPopUp={false}
                />
            }
            {stateLocal.showComprovanteFolhaA4 && flowVendaTORef.current !== null &&
                <RomaneioVenda
                    dados={flowVendaTORef.current}
                    onGoBack={goBackA4}
                />
            }
            {stateLocal.showComprovantePreVenda &&
                <PreVendaPdf
                    {...prevenda}
                    onClose={onCloseComprovantePreVenda}
                    key="pre-venda-pdf-tela-venda"
                />
            }
            {stateLocal.showCrediario && flowVendaTORef.current &&
                <PdfComprovanteCrediario
                    key="pdf-comprovante-crediario"
                    flowVendaTO={flowVendaTORef.current}
                    emissaoNota={emissaoNotaRef}
                    onCloseComprovante={onCloseCrediario}
                />
            }
            {stateLocal.dadosEtiqueta && stateLocal.showEtiquetaVolume &&
                <EtiquetaVolume
                    dadosEtiqueta={stateLocal.dadosEtiqueta}
                    onGoBack={onCloseEtiquetaVolume}
                />
            }
            {stateLocal.etiquetaSimplificada && stateLocal.showEtiquetaSimplificada &&
                <EtiquetaSimplificada
                    etiquetaSimplificada={stateLocal.etiquetaSimplificada}
                    barCode={stateLocal.barCode}
                    onGoBack={onCloseEtiquetaSimplificada}
                />
            }
            {stateLocal.visualizarVenda.open && (
                <VisualizarVenda
                    visualizar={stateLocal.visualizarVenda}
                    onClose={onCloseVisualizarVenda}
                />
            )}
        </Container >
    );
};
export default Venda;
